<template>
  <span class="label label--anchor-page-badge" :class="{'label-md': size === 'md'}">
    Anchor
  </span>
</template>

<script>
export default {
  name: 'AnchorPageLabel',
  props: {
    size: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.label.label--anchor-page-badge {
  background: #1c5498;
  color: #f8e81c;
  font-size: 75%;
  font-weight: 500;
  text-transform: uppercase;
  padding: 0.3em 0.7em 0.4em;

  &.label-md {
    font-size: 85%;
  }
}
</style>
